import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Checkbox,
  Dropdown,
  Button
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardMedRequestReturnUX = (props: any) => {
    return(
      <div
        id="CardMedRequestReturnUX-div-0"
        style={{padding:"5px"}}>
        <div
          id="CardMedRequestReturnUX-div-1"
          style={{fontWeight: "bold", fontSize: "1.2rem",marginTop:"10px"}}>
          {props.languageUX === "en" ? "Medical supply refund history" : "ประวัติการขอคืนเวชภัณฑ์"}
        </div>
        <div
          id="CardMedRequestReturnUX-div-2"
          style={{display: "flex", alignItems: "center", flexWrap: "wrap",marginTop:"10px" }}>
          
          <div
            id="CardMedRequestReturnUX-div-5"
            style={{display: "flex", alignItems: "center", margin: "0 10px 10px 0"}}>
            
            <Checkbox
              checked={props?.checkedDivisionReturn}
              id="CardMedRequestReturnUX-Checkbox-12"
              onChange={props.handleChangeChecked("checkedDivisionReturn")}>
            </Checkbox>
            <div
              id="CardMedRequestReturnUX-div-13"
              style={{margin: "0 5px 0 5px"}}>
              {props.languageUX === "en" ? "Return Agency" : "หน่วยงานคืน"}
            </div>
            <Dropdown
              defaultValue="แสดงทุกหน่วยงาน"
              id="CardMedRequestReturnUX-Dropdown-14"
              onChange={props.handleChangeValue("selectedDivisionReturn","checkedDivisionReturn")}
              options={props?.divisionOptions}
              search={true}
              selection={true}
              value={props?.selectedDivisionReturn}>
            </Dropdown>
          </div>
          <div
            id="CardMedRequestReturnUX-div-37"
            style={{display: "flex", alignItems: "center", margin: "0 10px 10px 0"}}>
            
            <Checkbox
              checked={props?.checkedDivisionReceive}
              id="CardMedRequestReturnUX-Checkbox-42"
              onChange={props.handleChangeChecked("checkedDivisionReceive")}>
            </Checkbox>
            <div
              id="CardMedRequestReturnUX-div-40"
              style={{margin: "0 5px 0 5px"}}>
              {props.languageUX === "en" ? "Receiving agency" : "หน่วยงานรับ"}
            </div>
            <Dropdown
              defaultValue="แสดงทุกหน่วยงาน"
              id="CardMedRequestReturnUX-Dropdown-44"
              onChange={props.handleChangeValue("selectedDivisionReceive","checkedDivisionReceive")}
              options={props?.divisionOptions}
              search={true}
              selection={true}
              value={props?.selectedDivisionReceive}>
            </Dropdown>
          </div>
          <div
            id="CardMedRequestReturnUX-div-7"
            style={{display: "flex", alignItems: "center", margin: "0 10px 10px 0"}}>
            
            <Checkbox
              checked={props?.checkedFilterDate}
              id="CardMedRequestReturnUX-Checkbox-18"
              onChange={props.handleChangeChecked("checkedFilterDate")}>
            </Checkbox>
            <div
              id="CardMedRequestReturnUX-div-19"
              style={{margin: "0 5px 0 5px"}}>
              {props.languageUX === "en" ? "Notification date" : "วันที่แจ้ง"}
            </div>
            <DateTextBox
              id="CardMedRequestReturnUX-DateTextBox-20"
              onChange={props.handleChangeDate("selectedStartDate","checkedFilterDate")}
              value={props?.selectedStartDate}>
            </DateTextBox>
            <DateTextBox
              id="CardMedRequestReturnUX-DateTextBox-21"
              onChange={props.handleChangeDate("selectedEndDate","checkedFilterDate")}
              style={{marginLeft:"10px"}}
              value={props?.selectedEndDate}>
            </DateTextBox>
          </div>
          <div
            id="CardMedRequestReturnUX-div-38"
            style={{display: "flex", alignItems: "center", margin: "0 10px 10px 0"}}>
            
            <Checkbox
              checked={props?.checkedStatus}
              id="CardMedRequestReturnUX-Checkbox-43"
              onChange={props.handleChangeChecked("checkedStatus")}>
            </Checkbox>
            <div
              id="CardMedRequestReturnUX-div-41"
              style={{margin: "0 5px 0 5px"}}>
              {props.languageUX === "en" ? "status" : "สถานะ"}
            </div>
            <Dropdown
              defaultValue="แสดงทุกสถานะ"
              id="CardMedRequestReturnUX-Dropdown-45"
              onChange={props.handleChangeValue("selectedStatus","checkedStatus")}
              options={props?.statuOptions}
              selection={true}
              value={props?.selectedStatus}>
            </Dropdown>
          </div>
          <div
            id="CardMedRequestReturnUX-div-39"
            style={{display: "flex", margin: "0 10px 10px 20px"}}>
            
            <Button
              color="blue"
              id="CardMedRequestReturnUX-Button-46"
              onClick={props.OnSearch}
              size="tiny">
              {props.languageUX === "en" ? "Search" : "ค้นหา"}
            </Button>
            <Button
              color="yellow"
              id="CardMedRequestReturnUX-Button-47"
              onClick={props.OnClear}
              size="tiny">
              {props.languageUX === "en" ? "wash" : "ล้าง"}
            </Button>
          </div>
        </div>
        <div
          id="CardMedRequestReturnUX-div-3">
          
          <Table
            data={props.MedRequestReturnList}
            getTrProps={props.handleRowProps}
            headers="เลขที่,รายการเวชภัณฑ์,ขอคืน,อนุมัติ,ส่ง,รับ,สถานะ"
            id="CardMedRequestReturnUX-Table-4"
            keys="code,listSupply,request,approve,delivery,receive,statusName"
            minRows="10"
            showPagination={false}
            style={{height: "400px"}}
            widths="120,auto,100,100,100,100,150">
          </Table>
        </div>
      </div>
    )
}


export default CardMedRequestReturnUX

export const screenPropsDefault = {"patientSearch":"[Patient Search Box]"}

/* Date Time : Wed Oct 01 2025 12:05:09 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{padding:\"5px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "ประวัติการขอคืนเวชภัณฑ์",
          "valueEN": "Medical supply refund history"
        },
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\",marginTop:\"10px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", flexWrap: \"wrap\",marginTop:\"10px\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-div-3"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 4,
      "name": "Table",
      "parent": 3,
      "props": {
        "data": {
          "type": "code",
          "value": "props.MedRequestReturnList"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.handleRowProps"
        },
        "headers": {
          "type": "value",
          "value": "เลขที่,รายการเวชภัณฑ์,ขอคืน,อนุมัติ,ส่ง,รับ,สถานะ"
        },
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-Table-4"
        },
        "keys": {
          "type": "value",
          "value": "code,listSupply,request,approve,delivery,receive,statusName"
        },
        "minRows": {
          "type": "value",
          "value": "10"
        },
        "pageSize": {
          "type": "code",
          "value": ""
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"400px\"}"
        },
        "widths": {
          "type": "value",
          "value": "120,auto,100,100,100,100,150"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"0 10px 10px 0\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"0 10px 10px 0\"}"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "Checkbox",
      "parent": 5,
      "props": {
        "checked": {
          "type": "code",
          "value": "props?.checkedDivisionReturn"
        },
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-Checkbox-12"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeChecked(\"checkedDivisionReturn\")"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "หน่วยงานคืน",
          "valueEN": "Return Agency"
        },
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-div-13"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 5px 0 5px\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "Dropdown",
      "parent": 5,
      "props": {
        "defaultValue": {
          "type": "value",
          "value": "แสดงทุกหน่วยงาน"
        },
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-Dropdown-14"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"selectedDivisionReturn\",\"checkedDivisionReturn\")"
        },
        "options": {
          "type": "code",
          "value": "props?.divisionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props?.selectedDivisionReturn"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "Checkbox",
      "parent": 7,
      "props": {
        "checked": {
          "type": "code",
          "value": "props?.checkedFilterDate"
        },
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-Checkbox-18"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeChecked(\"checkedFilterDate\")"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่แจ้ง",
          "valueEN": "Notification date"
        },
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 5px 0 5px\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 20,
      "name": "DateTextBox",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-DateTextBox-20"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeDate(\"selectedStartDate\",\"checkedFilterDate\")"
        },
        "value": {
          "type": "code",
          "value": "props?.selectedStartDate"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 21,
      "name": "DateTextBox",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-DateTextBox-21"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeDate(\"selectedEndDate\",\"checkedFilterDate\")"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"10px\"}"
        },
        "value": {
          "type": "code",
          "value": "props?.selectedEndDate"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-div-37"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"0 10px 10px 0\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-div-38"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"0 10px 10px 0\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-div-39"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", margin: \"0 10px 10px 20px\"}"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": "หน่วยงานรับ",
          "valueEN": "Receiving agency"
        },
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 5px 0 5px\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะ",
          "valueEN": "status"
        },
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-div-41"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 5px 0 5px\"}"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "Checkbox",
      "parent": 37,
      "props": {
        "checked": {
          "type": "code",
          "value": "props?.checkedDivisionReceive"
        },
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-Checkbox-42"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeChecked(\"checkedDivisionReceive\")"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "Checkbox",
      "parent": 38,
      "props": {
        "checked": {
          "type": "code",
          "value": "props?.checkedStatus"
        },
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-Checkbox-43"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeChecked(\"checkedStatus\")"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "Dropdown",
      "parent": 37,
      "props": {
        "defaultValue": {
          "type": "value",
          "value": "แสดงทุกหน่วยงาน"
        },
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-Dropdown-44"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"selectedDivisionReceive\",\"checkedDivisionReceive\")"
        },
        "options": {
          "type": "code",
          "value": "props?.divisionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props?.selectedDivisionReceive"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "Dropdown",
      "parent": 38,
      "props": {
        "defaultValue": {
          "type": "value",
          "value": "แสดงทุกสถานะ"
        },
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-Dropdown-45"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"selectedStatus\",\"checkedStatus\")"
        },
        "options": {
          "type": "code",
          "value": "props?.statuOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props?.selectedStatus"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "Button",
      "parent": 39,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-Button-46"
        },
        "onClick": {
          "type": "code",
          "value": "props.OnSearch"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "Button",
      "parent": 39,
      "props": {
        "children": {
          "type": "value",
          "value": "ล้าง",
          "valueEN": "wash"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardMedRequestReturnUX-Button-47"
        },
        "onClick": {
          "type": "code",
          "value": "props.OnClear"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        }
      },
      "seq": 47,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardMedRequestReturnUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "patientSearch": "[Patient Search Box]"
  },
  "width": 80
}

*********************************************************************************** */
